import styled from "styled-components";
import React from "react";
import { getFooterByPartner } from "../../api/axios";
import useSWR from "swr";
import { Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
 import { ReactComponent as FacebookIcon } from "../../Assets/Images/Footer/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../Assets/Images/Footer/twitter.svg";
import { ReactComponent as LinkedinIcon } from "../../Assets/Images/Footer/linkedin.svg";
import { ReactComponent as InstagramIcon } from "../../Assets/Images/Footer/instagram.svg";
import { ReactComponent as PinterestIcon } from "../../Assets/Images/Footer/pinterest.svg";
import { ReactComponent as EmailIcon } from "../../Assets/Images/Footer/emailicon.svg";
import { ReactComponent as Teliphone } from "../../Assets/Images/Footer/telephoneicon.svg";
import { ReactComponent as AddressIcons } from "../../Assets/Images/Footer/addressicon.svg";
import { Link } from "react-router-dom";
const Footer = () => {
  //fetch footer data
  const { data = [] } = useSWR(
    `aboutUsgetFooter`,
    async () => {
      try {
        const { data } = await getFooterByPartner();
        return data?.data || [];
      } catch (error) {
        console.error("error: ", error);
        alert(error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );
  const theme = useTheme();
  const Body = styled.div`
  background: ${theme.palette.footer.main};
  
  @media (max-width: 768px) {
    text-align: center;
    align-items: center;
    justify-content: center;
    background: ${theme.palette.footer.main};
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
  
  @media (max-width: 375px) {
    padding: 0 5px;
  }
`;

const Paragraph = styled.p`
  display: flex;
  align-items: center;
  justify-content: end;
  color: white;
  margin: 0px;
  padding: 30px 0;
  color: ${theme.palette.footer.text};

  a {
    color: ${theme.palette.footer.text};
    text-decoration: none;
  }
  
  img {
    height: 25px;
    width: 25px;
  }
  
  @media (max-width: 1200px) {
    padding-top: 20px;
    padding-bottom: 10px;
    justify-content: center;
  }
  
  @media (max-width: 850px) {
    justify-content: center;
    padding: 15px 0;
  }
  
  @media (max-width: 750px) {
    padding: 10px 0;
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 0;
    font-size: 13px;
    gap: 5px;
  }
  
  @media (max-width: 375px) {
    padding: 6px 0;
    font-size: 12px;
  }
`;

const BottomBox = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${theme.palette.footer.text};

  @media (max-width: 1200px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    gap: 15px;
    padding: 0 10px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
    padding: 0 5px;
  }
`;

  return (
    <Body>
      {data.map((item, index) => {
        return (
          <Container maxWidth="xl" key={index}>
            <Footergroup>
              <LeftBox>
                <Newgroup>
                  <Text key={item.id} style={{color: theme.palette.footer.text}}>{item.paragraph}</Text>

                  <Content>
                    <p>
                      <Link to="/account" style={{color: theme.palette.footer.text}}>Member Login</Link>
                    </p>
                    <p>
                      <Link to="/resources" style={{color: theme.palette.footer.text}}>Resources</Link>
                    </p>
                    <p>
                      <Link to="/aboutus" style={{color: theme.palette.footer.text}}>About Us</Link>
                    </p>
                    <p>
                      <Link to="/resources" style={{color: theme.palette.footer.text}}>Blog</Link>
                    </p>
                    <p>
                      <a href="/privacypolicy">
                        Privacy Policy
                      </a>
                    </p>
                  </Content>
                </Newgroup>
              </LeftBox>
              <ContactImageGroup>
                <ParentComapanyBox>
                  <Textlink>
                    <div style={{color: theme.palette.footer.text}}>Visit our parent company</div>
                    <Foot>
                      <RO>
                        <a href="https://footprintid.com/" target="_blank"> FootprintID </a>
                        <a href="https://footprintid.com/" target="_blank">
                          <img
                            src={require("../../Assets/Images/Footer/favicon.ico")}
                            alt="pawprintlogo"
                          />
                        </a>
                      </RO>
                    </Foot>
                  </Textlink>
                </ParentComapanyBox>
                <ContactDetails>
                  <SocialMedia>
                    <a href={item.facebook} target="_blank" rel="noreferrer" style={{color: theme.palette.footer.text}}>
                      <FacebookIcon width={24} height={24} style={{fill:theme.palette.footer.text}}/>
                    </a>
                      <a href={item.twitter} target="_blank" rel="noreferrer" style={{color: theme.palette.footer.text}}>
                      <TwitterIcon width={24} height={24} style={{fill:theme.palette.footer.text}}/>
                    </a>
                    <a href={item.linkedin} target="_blank" rel="noreferrer" style={{color: theme.palette.footer.text}}>
                      <LinkedinIcon width={24} height={24} style={{fill:theme.palette.footer.text}}/>
                    </a>
                    <a href={item.instagram} target="_blank" rel="noreferrer" style={{color: theme.palette.footer.text}}>
                      <InstagramIcon width={24} height={24} style={{fill:theme.palette.footer.text}}/>
                    </a>
                    <a href={item.pinterest} target="_blank" rel="noreferrer" style={{color: theme.palette.footer.text}}>
                      <PinterestIcon width={24} height={24} style={{fill:theme.palette.footer.text}}/>
                    </a>
                  </SocialMedia>
                  <AppStore>
                    <AppWrapper>
                      <a href="https://apps.apple.com/us/app/pawprintid/id1551145317" target="_blank">
                        <img
                          src={require("../../Assets/Images/Footer/app-store.png")}
                          alt="appstore"
                          style={{
                            // maxWidth: "10vw",
                            width: "132px",
                            height: "50px",
                            borderRadius: "10px",
                          }}
                        />
                      </a>

                      <a href="https://play.google.com/store/apps" target="_blank">
                        <img
                          src={require("../../Assets/Images/Footer/playStore.jpg")}
                          alt="playstore"
                          style={{
                            // maxWidth: "10vw",
                            width: "132px",
                            height: "50px",
                            borderRadius: "10px",
                          }}
                        />{" "}
                      </a>
                    </AppWrapper>
                  </AppStore>
                </ContactDetails>
              </ContactImageGroup>
            </Footergroup>
            <Resounces>
              <p>
                <Link to="/account">Member Login</Link>
              </p>
              <p>
                <Link to="/resources">Resources</Link>
              </p>
              <p>
                <Link to="/aboutus">About Us</Link>
              </p>
              <p>
                <Link to="/resources">Blog</Link>
              </p>
              <p>
                <a href="/privacypolicy">
                  Privacy Policy
                </a>
              </p>
            </Resounces>
            <BottomBox>
              <CopyRight style={{color: theme.palette.footer.text}}>
                {/* <p> */}
                &copy;{new Date().getFullYear()} Copyright PawprintID, All
                Rights Reserved
                {/* </p> */}
              </CopyRight>
              <ContactBox>
                <Paragraph style={{color: theme.palette.footer.text}}>
                 <AddressIcons width={20} height={20}  fill={theme.palette.footer.text}/>
                  &nbsp;
                  {item.mailing_address}
                </Paragraph>
                  <Paragraph>
                   <Teliphone  width={20} height={20}  fill={theme.palette.footer.text}/>       
                  &nbsp;
                  <a href="tel:855-374-3411">{item.phoneNo}</a>
                </Paragraph>
                <Paragraph>
                  <EmailIcon width={24} height={24}  fill={theme.palette.footer.text}/>        
                  &nbsp;
                  <a href="mailto:info@pawprintid.com">{item.email_address}</a>
                </Paragraph>
              </ContactBox>
            </BottomBox>
          </Container>
        );
      })}
    </Body>
  );
};

export default Footer;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 25px;

  a {
    line-height: 0;
  }

  @media (max-width: 1200px) {
    flex-direction: row;
    gap: 15px;
  }
  
  @media (max-width: 850px) {
    gap: 20px;
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    justify-content: center;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
    
    img {
      width: 100px !important;
      height: 40px !important;
    }
  }
  
  @media (max-width: 375px) {
    gap: 8px;
    
    img {
      width: 90px !important;
      height: 35px !important;
    }
  }
`;
const RO = styled.div`
  a {
    text-decoration: none;
  }
  img {
    height: 20px;
    width: 20px;
  }
`;

const Foot = styled.div`
  padding-top: 10px;
  @media (max-width: 1280px) {
    justify-content: start;
  }
`;
const Textlink = styled.div`
  padding-top: 30px;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;

  a {
    color: rgba(0, 143, 211, 1);
  }

  @media (max-width: 1200px) {
    text-align: center;
    font-size: 18px;
  }
  
  @media (max-width: 768px) {
    text-align: center;
    font-size: 16px;
    padding-top: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    padding-top: 15px;
  }
  
  @media (max-width: 375px) {
    font-size: 13px;
    padding-top: 10px;
  }
`;

const Footergroup = styled.div`
  padding: 0px;
  display: flex;
  padding-bottom: 30px;
  
  @media (max-width: 1200px) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 20px;
  }
  
  @media (max-width: 850px) {
    padding: 25px 0px;
    grid-template-columns: repeat(1, auto);
  }
  
  @media (max-width: 768px) {
    padding: 20px 0px;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    padding: 15px 0px;
    gap: 10px;
  }
  
  @media (max-width: 375px) {
    padding: 10px 0px;
    gap: 8px;
  }
`;

const Newgroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  @media (max-width: 1200px) {
    width: 100%;
    gap: 10px;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    gap: 6px;
  }
`;

const ParentComapanyBox = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  @media (max-width: 1200px) {
    width: 100%;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const LeftBox = styled.div`
  display: flex;
  width: 50%;
  
  @media (max-width: 1200px) {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
`;

const ContactImageGroup = styled.div`
  display: flex;
  width: 50%;
  grid-gap: 40px;

  @media (max-width: 1200px) {
    width: 100%;
    justify-content: center;
    gap: 100px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  
  @media (max-width: 480px) {
    gap: 15px;
  }
  
  @media (max-width: 375px) {
    gap: 10px;
  }
`;

const CopyRight = styled.p`
  color: white;
  margin: 0px;
  padding: 30px 0;
  text-align: center;

  @media (max-width: 1200px) {
    padding-top: 10px;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    font-size: 13px;
    padding: 15px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    padding: 10px 0;
  }
  
  @media (max-width: 375px) {
    font-size: 11px;
    padding: 8px 0;
  }
`;

const ContactBox = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: 1200px) {
    width: 100%;
    gap: 20px;
    flex-direction: column;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    gap: 0px;
  }
  
  @media (max-width: 375px) {
    gap: 0px;
  }
`;

const Text = styled.div`
  margin-top: 30px;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: justify;
  color: #ffffff;
  
  @media (max-width: 1280px) {
    margin-top: 30px;
    padding-top: 0px;
  }
  
  @media (max-width: 1200px) {
    text-align: center;
    font-size: 18px;
  }
  
  @media (max-width: 850px) {
    margin-top: 10px;
    font-size: 16px;
  }
  
  @media (max-width: 768px) {
    font-size: 15px;
    margin-top: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-top: 5px;
  }
  
  @media (max-width: 375px) {
    font-size: 13px;
    margin-top: 3px;
  }
`;

const Content = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
  color: #ffffff;
  display: flex;
  gap: 30px;
  padding-top: 30px;
  text-align: left;
  
  p {
    margin: 10px 0px;
  }
  
  a {
    color: inherit;
    font-family: inherit;
    text-decoration: none;
  }
  
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Resounces = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
  color: #ffffff;
  display: flex;
  gap: 0px 30px;
  flex-wrap: wrap;
  padding-bottom: 30px;
  justify-content: center;
  
  p {
    margin: 10px 0px;
  }
  
  a {
    color: inherit;
    font-family: inherit;
    text-decoration: none;
  }
  
  @media (min-width: 1200px) {
    display: none;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    gap: 0px 20px;
    padding-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    gap: 0px 15px;
    padding-bottom: 15px;
  }
  
  @media (max-width: 375px) {
    font-size: 12px;
    gap: 0px 10px;
    padding-bottom: 10px;
  }
`;

const ContactDetails = styled.div`
  padding-top: 30px;
  text-align: right;
  font-weight: 500;
  font-size: 16px;
  text-align: right;
  color: #ffffff;
  line-height: 1.5;
  display: inline-block;
  vertical-align: middle;

  a {
    text-decoration: none;
    color: #ffffff;
  }

  @media (max-width: 1280px) {
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  
  @media (max-width: 850px) {
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding-top: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    padding-top: 15px;
  }
  
  @media (max-width: 375px) {
    font-size: 12px;
    padding-top: 10px;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  justify-content: end;
  gap: 30px;

  img {
    height: 26px;
    width: 26px;
  }

  @media (max-width: 768px) {
    justify-content: center;
    gap: 20px;
  }
  
  @media (max-width: 480px) {
    gap: 15px;
  }
  
  @media (max-width: 375px) {
    gap: 10px;
  }
`;

const AppStore = styled.div`
  padding-top: 15px;
  
  @media (max-width: 1280px) {
    text-align: center;
  }
  
  @media (max-width: 768px) {
    padding-top: 10px;
  }
  
  @media (max-width: 480px) {
    padding-top: 8px;
  }
`;


